import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { QuestionItemV2 } from '@examdojo/models/question';
import { filter, from, tap } from 'rxjs';
import { QuestionItemsFormService } from '../question-items-form.service';
import { JsonEditorDialogService } from './json-editor-dialog.service';

@Injectable()
export class QuestionItemsJsonEditorService {
  constructor(
    private readonly dialogService: JsonEditorDialogService,
    private readonly questionItemsFormService: QuestionItemsFormService,
    private readonly destroyRef: DestroyRef,
  ) {}

  openEditor() {
    this.questionItemsFormService.setActiveQuestionItem(null);

    const data = this.questionItemsFormService.getFormData();

    const dialogInput = JSON.stringify(data, null, 2);

    from(this.dialogService.openDialog({ input: dialogInput }))
      .pipe(
        filter(Boolean),
        tap((result) => {
          try {
            // TODO: validate for the valid question items pattern, not just valid json and throw error if invalid
            const updatedQuestionItems = JSON.parse(result) as QuestionItemV2[];

            const hasContentChanged = JSON.stringify(data) !== JSON.stringify(updatedQuestionItems);

            if (hasContentChanged) {
              this.questionItemsFormService.jsonEditorUpdatedQuestionItems$.next(updatedQuestionItems);

              this.questionItemsFormService.form.markAsDirty();
              this.questionItemsFormService.form.markAllAsTouched();
            }
          } catch (error) {
            console.error('Invalid JSON', error);
            return;
          }
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
